import {PIXI} from '@colonist/pixi'

export module AsyncAssetLoader {
    export async function getAsyncTexture(assetUrl: string,): Promise<PIXI.Texture> {
        return await PIXI.Assets.load(assetUrl) as unknown as PIXI.Texture
    }

    export async function getAsyncTextureExternal(assetExternalUrl: string): Promise<PIXI.Texture> {
        return await PIXI.Assets.load(assetExternalUrl) as unknown as PIXI.Texture
    }
}
